import { useState, useEffect, useContext } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import Context from "../../../context";
import { API_URL } from "../../data/constants";
import axios from "axios";
import dayjs from "dayjs";
import StatementList from "./StatementList";
import WorksheetList from "./WorksheetList";

export default function BillsUsagePage({ setSubPage }) {
  const { contextState, setContextState } = useContext(Context);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [numItems, setNumItems] = useState(0);
  const [currentStatements, setCurrentStatements] = useState([]);
  const [chartList, setChartList] = useState([]);
  const [chartOption, setChartOption] = useState("balance"); // balance, therms
  const [isLoading, setIsLoading] = useState(true);
  
  let account = contextState.currentAccount;
  let userRole = localStorage.getItem("userRole");

  useEffect(() => {
      setIsLoading(true);
      axios
          .post(
              API_URL + "/Statements/Chart",
              {
                  customerId: account?.contract?.customerId,
                  customerNumber: account?.customerNumber,
                  masterCustomerId: null,
                  userName: null,
              },
              {
                  headers: {
                      Authorization: `${localStorage.getItem("accessToken")}`,
                  },
              }
          )
          .then((res) => {
              res?.data?.forEach((current) => {
                  current["accountingMonth"] = dayjs(current.accountingMonth).format(
                      "MMMM"
                  );
                  current["invoiceTotal"] = current.invoiceTotal.toFixed(2);
                  current["therms"] = current.therms.toFixed(2);
              });
            
              setChartList(res.data);
              setContextState({ ...contextState, chartData: res?.data });
              setIsLoading(false);
          })
          .catch((err) => console.error(err));
  }, []);
  
  return (
    <>
        {isLoading ? (
            <div className="d-flex justify-content-center align-items-center">
                <div className="spinner-border mr-4" role="status"/>
                <h4>Loading Bills & Usage...</h4>
            </div>
        ) : (
          <div className="chart-wrapper">
            <ResponsiveContainer height={280}>
              <BarChart
                width={500}
                height={300}
                data={chartList}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
                fill="#67BD45">
                <CartesianGrid />
                <XAxis dataKey="accountingMonth" />
                <YAxis />
                <Tooltip />
                <Bar
                    name={chartOption === "balance" ? "Bill Total" : userRole === "IT-User" ? "Dekatherms" : "Therms"}
                    dataKey={chartOption === "balance" ? "invoiceTotal" : "therms"}
                />
              </BarChart>
            </ResponsiveContainer>
            <ul className="nav mx-n3 justify-content-center">
              <li className="nav-item">
                <div className="nav-link">
                  <div
                    className={`radio${
                      chartOption === "balance" ? " selected" : ""
                    }`}
                    onClick={() => setChartOption("balance")}>
                    <div className="radio-input" />
                    <label className="radio-label">Bill History</label>
                  </div>
                </div>
              </li>
              <li className="nav-item">
                <div className="nav-link">
                  <div
                    className={`radio${
                      chartOption === "therms" ? " selected" : ""
                    }`}
                    onClick={() => setChartOption("therms")}>
                    <div className="radio-input" />
                    <label className="radio-label">{userRole === "IT-User" ? "Usage History (Dekatherms)" : "Usage History (Therms)"}</label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        )}
        {isLoading ? (
           <></>
        ) : (
            userRole === "IT-User" && chartOption === "therms" ? 
                (<WorksheetList/>) :
                (<StatementList/>)
        )}
    </>
  );
}
